module.exports = __webpack_public_path__ + "assets/media/info-icon-2.3382e581.svg";